import { backendRequest } from 'services/request'

export function getGraphs(params) {
  return backendRequest({
    url: '/aetos-x-data-processing/graphs',
    method: 'get',
    params
  })
}

export function ingest(data) {
  return backendRequest({
    url: '/aetos-x-data-processing/ingest',
    method: 'post',
    data
  })
}

export function getTasks(params) {
  return backendRequest({
    url: '/aetos-x-data-processing/tasks',
    method: 'get',
    params
  })
}

export function resubmitTask(taskName) {
  return backendRequest({
    url: `/aetos-x-data-processing/tasks/resubmit`,
    method: 'post',
    data: { name: taskName }
  })
}

export function cancelTask(taskName) {
  return backendRequest({
    url: `/aetos-x-data-processing/tasks/cancel`,
    method: 'post',
    data: { name: taskName }
  })
}

export function getTaskLogs(taskName) {
  return backendRequest({
    url: `/aetos-x-data-processing/tasks/log`,
    method: 'get',
    params: { name: taskName }
  })
}
